import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import { isEqual } from "lodash";
import React, { useCallback } from "react";
import "./index.scss";
import { SET_AUDIT_PROPERTIES_DATA, TOGGLE_UPDATE_REQUESTER_INFO_WARNING_POPUP, shouldSetClaimType } from "./reducers/audit-properties-reducer";
import { callOperation } from "async-ops";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../common_components/mdae-common-reducer";
import { UPDATE_ROUND_DATA_BY_SEQUENCE_NO } from "./reducers/external-audit-reducer";
import { UPDATE_ROUND_CASES } from "./services/update-round-cases";
import { refreshCaseListFromDb } from "./case-list/case-list-detail";
import { GET_EA_REQUESTER_BY_ID } from "./services/get-requester-by-id";

export const toggleUpdateInitialRequesterOrganizationWarningPopup = (
  dispatch,
  isVisible
) => {
  dispatch({
    type: TOGGLE_UPDATE_REQUESTER_INFO_WARNING_POPUP,
    data: {
      isUpdateInitialRequesterOrganizationPopupVisible: isVisible,
    },
  });
};

const UpdateInitialRequesterOrganizationWarningPopup: React.FC<any> = () => {
  const dispatch = useDispatch();

  const isUpdateInitialRequesterOrganizationPopupVisible = useSelector(
    (state) =>
      state["auditPropertiesReducer"]
        .isUpdateInitialRequesterOrganizationPopupVisible,
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );

  const eaAuditRounds = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds,
    isEqual
  );

  const updateRoundRequesterInfo = useCallback(
    (refreshRoundCases = true) => {
      if (auditPropertiesData.eaRequesterId > 0) {
        dispatch({ type: SHOW_LOADER });
  
        callOperation(GET_EA_REQUESTER_BY_ID, {
          requesterId: auditPropertiesData.eaRequesterId,
        }).then((response) => {
          const eaAuditRound = {
            sequenceNo: 1,
            rqstrOrganizationName: response?.rqstrOrganizationName,
            rqstrMainPhoneNumber: response?.rqstrMainPhoneNumber,
            rqstrMainEmail: response?.rqstrMainEmail,
            rqstrContactName: response?.rqstrContactName,
            rqstrContactPhoneNumber: response?.rqstrContactPhoneNumber,
            rqstrContactEmail: response?.rqstrContactEmail,
            rqstrNotes: response?.rqstrNotes,
            rqstrRecordSubmissionMethod:response.rqstrRecordSubmissionMethod,
            rqstrRecordSubmissionValue: response.rqstrRecordSubmissionValue,
            claimTypeCd: response?.claimTypeCd,
            eaSourceId: response?.eaSourceId,
            requesterId: auditPropertiesData.eaRequesterId,
            eaRoundId: eaAuditRounds.find((x) => x.sequenceNo === 1)?.eaRoundId,
            eaAuditId: auditPropertiesData.eaAuditId,
            isUpdateCases: refreshRoundCases,
          };
  
          if (refreshRoundCases) {
            dispatch({
              type: UPDATE_ROUND_DATA_BY_SEQUENCE_NO,
              data: { eaAuditRound },
            });
          }
  
          callOperation(UPDATE_ROUND_CASES, eaAuditRound).then(() => {
            dispatch({ type: HIDE_LOADER });
            if (refreshRoundCases) {
              refreshCaseListFromDb(dispatch, auditPropertiesData?.eaAuditId);
            }
          });
        });
      }
  
      toggleUpdateInitialRequesterOrganizationWarningPopup(dispatch, false);
    },
    [auditPropertiesData, eaAuditRounds, dispatch]
  );
  
  const RevertSelectedRequester = useCallback(() => {
    if (auditPropertiesData.previousEaRequesterId > 0) {
      callOperation(GET_EA_REQUESTER_BY_ID, {
        requesterId: auditPropertiesData.previousEaRequesterId,
      }).then((response) => {
        const shouldSetClaim = dispatch(shouldSetClaimType);
  
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              ...(shouldSetClaim && {
                claimTypeCd: response.claimTypeCd,
              }),
              eaSourceId: response.eaSourceId,
              rqstrRecordSubmissionMethod:
                response?.rqstrRecordSubmissionMethod,
              eaRequesterId: auditPropertiesData.previousEaRequesterId,
            },
          },
        });
      });
    }
  
    toggleUpdateInitialRequesterOrganizationWarningPopup(dispatch, false);
  }, [auditPropertiesData.previousEaRequesterId, dispatch]);
  
  const getPopupTitle = useCallback(() => {
    return (
      <MdaePopupTitle
        isSmallPopup={true}
        closePopupHandler={() =>{
          RevertSelectedRequester();
          toggleUpdateInitialRequesterOrganizationWarningPopup(dispatch, false);
        }}
      >
        Alert
      </MdaePopupTitle>
    );
  }, [dispatch]);

  return (
    <MdaePopup
      deferRendering={false}
      height={250}
      width={450}
      className="update-initial-requester-organization-alert-popup"
      mdaeTitleRender={getPopupTitle}
      visible={isUpdateInitialRequesterOrganizationPopupVisible}
      mdaeContentRender={() => {
        return (
          <div>
            <MdaePopupContent>
              <div className="update-initial-requester-organization-alert-popup-content">
                One or more of your cases have a different Requester selected
                for Round 1. Would you like to update these cases with this new
                selection?
              </div>
            </MdaePopupContent>
          </div>
        );
      }}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterStartButtons>
              <MdaeButton
                id={"pnlUpdateInitialRequesterOrgWarningCancelButton"}
                role={"secondary"}
                onClick={RevertSelectedRequester}
              >
                Cancel
              </MdaeButton>
            </MdaePopupFooterStartButtons>
            <MdaePopupFooterEndButtons>
              <MdaeButton
                id={"pnlUpdateRequesterInfoWarningPopupSecondaryButton"}
                role={"primary"}
                onClick={() => {updateRoundRequesterInfo(false);}}
              >
                No
              </MdaeButton>

              <MdaeButton
                id={"pnlUpdateInitialRequesterOrgWarningYesButton"}
                role={"primary"}
                onClick={() => {updateRoundRequesterInfo(true);}}
              >
                Yes
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};

export default UpdateInitialRequesterOrganizationWarningPopup;
